import type { UserCredential } from "firebase/auth"

export const isFirebaseUserCredential = (
  subject: UserCredential | Error
): subject is UserCredential => {
  return (
    subject &&
    typeof subject === `object` &&
    Object.hasOwn(subject, `user`) &&
    Object.hasOwn(subject, `providerId`) &&
    Object.hasOwn(subject, `operationType`)
  )
}
